import { Button } from "@material-ui/core";
import { CSSProperties } from "react";

interface RxButtonProps {
	onClick?: () => void;
	color?: "default" | "inherit" | "primary" | "secondary";
	variant?: "contained" | "outlined" | "text";
	type?: "button" | "submit" | "reset";
	style?: CSSProperties;
	fullWidth?: boolean;
	disabled?: boolean;
	label?: string;
	size?: "small" | "medium" | "large";
	className?: string;
	ref?: any;
	id?: string;
}

const RxButton = (props: RxButtonProps) => {
	// const isLoading = useSelector((str: any) => str.load.isLoading || false);

	return (
		<Button
			id={props.id}
			fullWidth={props.fullWidth}
			variant={props.variant}
			color={props.color}
			onClick={props.onClick}
			type={props.type}
			// disabled={isLoading || props.disabled}
			disabled={props.disabled}
			style={props.style ?? undefined}
			size={props.size}
			className={props.className}
			ref={props.ref}
		>
			{props.label}
		</Button>
	);
};
export default RxButton;
